import { render, staticRenderFns } from "./reasonCom.vue?vue&type=template&id=72e97f17&scoped=true&"
import script from "./reasonCom.vue?vue&type=script&lang=ts&"
export * from "./reasonCom.vue?vue&type=script&lang=ts&"
import style0 from "./reasonCom.vue?vue&type=style&index=0&id=72e97f17&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e97f17",
  null
  
)

export default component.exports